import { EVENT_ACTION } from "../../constants/analytics.es.js";
import { EVENT_PRODUCER_URL } from "../../../constants/api.es.js";
import { generateFreedomPayload } from "../utils/generateFreedomPayload.es.js";
import { logger } from "../../../utils/logger.es.js";
import { setEventProducerUrl } from "../../../utils/eventProducerUrl.es.js";
import "../utils/addHashedData.es.js";
import "../utils/hashUtils.es.js";
import "../utils/extractApplicationData.es.js";
import "../utils/pageUtils.es.js";
import "../../constants/profileFields.es.js";
import "../../../pickFields-27454ddf.js";
import "../utils/extractClickData.es.js";
import "../utils/extractEventData.es.js";
import "../utils/extractCommonPayload.es.js";
import "../../../analytics-plugin-original-source.browser.es-e6f690eb.js";
import "../utils/getUtmParams.es.js";
import "../../../mapKeys-251205e5.js";
import "../utils/extractIds.es.js";
import "../utils/getBrowserID.es.js";
import "../../../cookies-04bd2321.js";
import "../../../v4-88c20f3b.js";
import "../utils/extractMetaTags.es.js";
import "../utils/extractMktgIds.es.js";
import "../utils/extractUrlData.es.js";
import "../utils/extractUserConsent.es.js";
import "../utils/extractUserDeviceData.es.js";
import "../../../_commonjsHelpers-7a77ea84.js";
import "../utils/extractFormData.es.js";
import "../../../server/validation/defaultSchema.es.js";
import "../../../getTealiumIds-c24d3498.js";
import "../../../waitFor-1b67bbb8.js";
import "../../../package-7dcca52d.js";
import "../../../videoData-64ad3ea2.js";
const analyticsFreedom = ({
  trackingUrl,
  userConfig = {},
  application,
  shouldExtractApplicationData = false,
  isDebug
}) => {
  const urlPassedFromClient = trackingUrl || EVENT_PRODUCER_URL;
  setEventProducerUrl(urlPassedFromClient);
  const pushEvent = async (payload) => {
    if (!urlPassedFromClient) {
      return;
    }
    const requestOptions = {
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
      method: "POST"
    };
    try {
      await fetch(urlPassedFromClient, requestOptions);
    } catch (e) {
      if (isDebug) {
        logger.error("analytics-freedom: track event failed");
      }
    }
  };
  return {
    config: Object.assign({}, userConfig),
    name: "analytics-freedom",
    page: async ({ payload }) => {
      const pageName = payload.properties.page_name;
      const eventName = `${pageName} - Page Loaded`;
      const payloadToSend = await generateFreedomPayload(
        payload,
        eventName,
        EVENT_ACTION.PAGE_VIEW,
        { application, shouldExtractApplicationData }
      );
      if (isDebug) {
        logger.info(
          `ANALYTICS :: freedom :: page - ${eventName}`,
          payloadToSend
        );
      }
      return pushEvent(payloadToSend);
    },
    track: async ({ payload, instance }) => {
      var _a, _b;
      const pageDataProperties = (_b = (_a = instance.getState("page")) == null ? void 0 : _a.last) == null ? void 0 : _b.properties;
      const pageName = payload.properties.page_name || pageDataProperties.page_name || pageDataProperties.application_data.page_name;
      const eventName = `${pageName} - ${payload.event}`;
      payload.properties.page_name = pageName;
      if (typeof window !== "undefined") {
        payload.properties.hash = (pageDataProperties == null ? void 0 : pageDataProperties.hash) || window.location.hash;
        payload.properties.path = (pageDataProperties == null ? void 0 : pageDataProperties.path) || window.location.pathname;
        payload.properties.search = (pageDataProperties == null ? void 0 : pageDataProperties.search) || window.location.search;
        payload.properties.url = (pageDataProperties == null ? void 0 : pageDataProperties.url) || window.location.href;
        payload.properties.referrer = (pageDataProperties == null ? void 0 : pageDataProperties.referrer) || document.referrer;
      }
      const payloadToSend = await generateFreedomPayload(
        payload,
        eventName,
        payload.properties.event_action,
        { application, shouldExtractApplicationData }
      );
      if (isDebug) {
        logger.info(
          `ANALYTICS :: freedom :: track - ${eventName}`,
          payloadToSend
        );
      }
      return pushEvent(payloadToSend);
    }
  };
};
export {
  analyticsFreedom,
  generateFreedomPayload
};
